import { Component, Vue } from 'vue-property-decorator'
import CAJG1010Service from './CAJG1010Service'
import CAJG1010ViewModel from './CAJG1010ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import '@/assets/css/colorbox.css'
import { TransportButton, DigitalBookButton } from '@/common/utils/modules-util'
import CommonConstants from '@/common/CommonConstants'
import TransportService from '@/common/TransportService'
import $ from 'jquery'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent } from '@/assets/js/main.js'

@Component({
  name: 'CAJG1010',
  components: {}
  })
export default class CAJG1010Controller extends Vue {
  private CommonConstants = CommonConstants
  private XSSFilterOptions = XSSFilterOptions
  private isShowStarterKit = true
  private isShowOtherMaterials = true
  private cajg1010ViewModel: CAJG1010ViewModel = {
    txtManlTxtBookSrvcGuidPmplt: {
      content: ''
    },
    txtManlCalCntrInternetGidc: {
      content: ''
    },
    txtManlSmtPlaSpecGrpPresentationFiles: {
      content: ''
    },
    txtManlOthFiles: {
      content: ''
    },
    operatProductLstInfo: {
      operatProductLstPdfName: '',
      operatProductLstPdfLnkUrl: ''
    },
    operatProductNewsInfo: {
      operatProductNewPdfName: '',
      operatProductNewPdfLnkUrl: ''
    }
  }

  private cajg1010Service: CAJG1010Service = new CAJG1010Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$nextTick(() => {
      const transportButton = new TransportButton('.js-write-log')
      const digitalBookButton = new DigitalBookButton('.js-digital-book')

      $('.unwrap_div').each(function() {
        $(this).children().unwrap()
      })

      if (this.$route.hash) {
        window.location.href = this.$route.hash
      }
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const [caja1010ResponseModel] = await Promise.all([
      this.cajg1010Service.callAPICAJA1010(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CAJG1010, null, null)
    ]) 
    
    if (
      CommonUtil.isNotEmpty(caja1010ResponseModel.txtManlTxtBookSrvcGuidPmplt)
    ) {
      this.cajg1010ViewModel.txtManlTxtBookSrvcGuidPmplt.content =
        CommonUtil.replacePathCMS(
          caja1010ResponseModel.txtManlTxtBookSrvcGuidPmplt.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1010ResponseModel.txtManlTxtBookSrvcGuidPmplt.path
        )
    } else {
      this.cajg1010ViewModel.txtManlTxtBookSrvcGuidPmplt = null
    }
    if (
      CommonUtil.isNotEmpty(caja1010ResponseModel.txtManlCalCntrInternetGidc)
    ) {
      this.cajg1010ViewModel.txtManlCalCntrInternetGidc.content =
        CommonUtil.replacePathCMS(
          caja1010ResponseModel.txtManlCalCntrInternetGidc.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1010ResponseModel.txtManlCalCntrInternetGidc.path
        )
    } else {
      this.cajg1010ViewModel.txtManlCalCntrInternetGidc = null
    }
    if (
      CommonUtil.isNotEmpty(
        caja1010ResponseModel.txtManlSmtPlaSpecGrpPresentationFiles
      )
    ) {
      this.cajg1010ViewModel.txtManlSmtPlaSpecGrpPresentationFiles.content =
        CommonUtil.replacePathCMS(
          caja1010ResponseModel.txtManlSmtPlaSpecGrpPresentationFiles.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1010ResponseModel.txtManlSmtPlaSpecGrpPresentationFiles.path
        )
    } else {
      this.cajg1010ViewModel.txtManlSmtPlaSpecGrpPresentationFiles = null
    }
    if (CommonUtil.isNotEmpty(caja1010ResponseModel.txtManlOthFiles)) {
      this.cajg1010ViewModel.txtManlOthFiles.content =
        CommonUtil.replacePathCMS(
          caja1010ResponseModel.txtManlOthFiles.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1010ResponseModel.txtManlOthFiles.path
        )
    } else {
      this.cajg1010ViewModel.txtManlOthFiles = null
    }
    if (caja1010ResponseModel.operatProductLstInfo) {
      this.cajg1010ViewModel.operatProductLstInfo =
        caja1010ResponseModel.operatProductLstInfo
    }
    if (caja1010ResponseModel.operatProductNewsInfo) {
      this.cajg1010ViewModel.operatProductNewsInfo =
        caja1010ResponseModel.operatProductNewsInfo
    }

    if (
      CommonUtil.isNotEmpty(
        caja1010ResponseModel.txtManlTxtBookSrvcGuidPmplt
      ) ||
      CommonUtil.isNotEmpty(caja1010ResponseModel.txtManlCalCntrInternetGidc) ||
      CommonUtil.isNotEmpty(
        caja1010ResponseModel.txtManlSmtPlaSpecGrpPresentationFiles
      ) ||
      (caja1010ResponseModel.operatProductLstInfo &&
        caja1010ResponseModel.operatProductLstInfo?.operatProductLstPdfName &&
        caja1010ResponseModel.operatProductLstInfo
          ?.operatProductLstPdfLnkUrl) ||
      (caja1010ResponseModel.operatProductNewsInfo &&
        caja1010ResponseModel.operatProductNewsInfo.operatProductNewPdfName &&
        caja1010ResponseModel.operatProductNewsInfo.operatProductNewPdfLnkUrl)
    ) {
      this.isShowStarterKit = true
    } else {
      this.isShowStarterKit = false
    }

    if (CommonUtil.isNotEmpty(caja1010ResponseModel.txtManlOthFiles)) {
      this.isShowOtherMaterials = true
    } else {
      this.isShowOtherMaterials = false
    }
  }

  /**
   * 運用商品一覧(CACG1010)画面に遷移する。
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }

  /**
   * PDFファイルを別タブで開く。
   * @param pdfFilePath
   */
  private openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }

  /**
   * 学習メニュートップ（ログイン後）(CAJG1060 )画面に遷移する。
   */
  private gotoCAJG1060() {
    this.$router.push({ name: 'cajg1060' })
  }
}
